var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4168 15.0834L15.0835 6.83337C15.8128 6.83337 16.5123 7.12311 17.028 7.63883C17.5438 8.15456 17.8335 8.85403 17.8335 9.58337V13.25H23.0218C23.2876 13.247 23.5508 13.3018 23.7933 13.4107C24.0357 13.5195 24.2516 13.6797 24.426 13.8803C24.6004 14.0808 24.7291 14.3169 24.8032 14.5721C24.8773 14.8273 24.895 15.0956 24.8552 15.3584L23.5902 23.6084C23.5239 24.0455 23.3018 24.444 22.9649 24.7304C22.628 25.0167 22.199 25.1717 21.7568 25.1667H11.4168M11.4168 15.0834V25.1667M11.4168 15.0834H8.66683C8.1806 15.0834 7.71428 15.2765 7.37047 15.6203C7.02665 15.9642 6.8335 16.4305 6.8335 16.9167V23.3334C6.8335 23.8196 7.02665 24.2859 7.37047 24.6297C7.71428 24.9736 8.1806 25.1667 8.66683 25.1667H11.4168",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.f23bda533f097057995378f6a755a51e.svg";
export { ForwardRef as ReactComponent };